<template>
  <div :class="'md-layout-item md-small-size-100'">
    <md-card>
      <md-card-content>
        <Form :fetched-review="fetchedReview" @setFormValidation="setFormValidation" />
        <md-card-actions md-alignment="left">
          <md-button :class="'md-default'" @click="$router.push({name: 'Review Reference'})">
            Back
          </md-button>
          <md-button :class="'md-danger'" @click.prevent="submit" :disabled="!isFormValid || isSubmitting">
            {{ !isSubmitting ? 'Edit' : 'Editing ARR...' }}
          </md-button>
        </md-card-actions>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
  import Form from './Form.vue'
  import { camelToSnake } from "@/methods/api/requests"

  export default {
    created() {
      this.$api.request(`advisories/${this.$route.params['id']}`)
        .then(response => {
          this.fetchedReview = camelToSnake({...response.data })
        })
        .catch(err => {
          if (err.response.status === 404) {
            return this.$router.go(-1)
          }
        })
    },

    data () {
      return {
        isSubmitting: false,
        fetchedReview: {},
        review: {},
        isFormValid: null,
        errorResponses: {
          422: 'There is an error with the Advisory',
        },
      }
    },

    components: {
      Form,
    },

    methods: {
      setFormValidation(validForm, review) {
        this.isFormValid = validForm
        this.review = review
      },

      submit () {
        if(this.isFormValid) {
          this.isSubmitting = true
          const arrToBeSent = Object.assign({}, this.review)
          arrToBeSent.start_date = new Date(arrToBeSent.start_date).toISOString().substring(0, 10)
          arrToBeSent.end_date = new Date(arrToBeSent.end_date).toISOString().substring(0, 10)
          arrToBeSent.deadline_docs = new Date(arrToBeSent.deadline_docs).toISOString().substring(0, 10)

          this.$api.request.put(`advisories/${this.$route.params['id']}`, arrToBeSent)
            .then(() => {
              this.$toast.show('ARR successfully edited', '')
              this.$router.push({ name: 'Review Reference' })
            })
            .catch(error => {
              const message = error.response.data.message ? error.response.data.message
                : 'Ops, something went wrong! Please, try again.'

              this.$toast.warning(message)
            })
            .finally(() => {
              this.isSubmitting = false
            })
        }
      },
    },
  }
</script>
